import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import { $investProDots } from '../../../models/investPro/index.js';

const onClusterClick = (e) => {
  const features = window.map.queryRenderedFeatures(e.point, {
    layers: ['invest_pro_dots_cluster_layer'],
  });
  const clusterId = features[0].properties.cluster_id;
  window.map
    .getSource(`invest_pro_dots_source`)
    .getClusterExpansionZoom(clusterId, (err, zoom) => {
      if (err) return;

      window.map.easeTo({
        center: features[0].geometry.coordinates,
        zoom,
      });
    });
};

const onDotClick = (e) => {
  const feature = e.features[0];
  const coordinates = feature.geometry.coordinates.slice();
  const html = `
    <div>Fuck you bitch</div>
  `;
  new mapboxgl.Popup().setLngLat(coordinates).setHTML(html).addTo(window.map);
};

function InvestProDotsLayer() {
  const mapLoaded = useUnit($mapLoaded);
  const dots = useUnit($investProDots);

  const createLayer = (update) => {
    const dotsData = {
      type: 'FeatureCollection',
      features: dots,
    };

    if (update) {
      window.map.getSource('invest_pro_dots_source').setData(dotsData);
    } else {
      if (!window.map.getSource('invest_pro_dots_source')) {
        window.map.addSource('invest_pro_dots_source', {
          type: 'geojson',
          data: dotsData,
          cluster: true,
          clusterMaxZoom: 14,
          clusterRadius: 50,
          generateId: true,
        });
      }

      if (!window.map.getLayer('invest_pro_dots_layer')) {
        // FIXME Cluster layer
        window.map.addLayer({
          id: 'invest_pro_dots_cluster_layer',
          type: 'circle',
          source: 'invest_pro_dots_source',
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': 'white',
            'circle-stroke-color': '#b3b3b3',
            'circle-stroke-width': 6,
            'circle-radius': 15,
          },
        });

        // FIXME Unclustered dots layer
        window.map.addLayer({
          id: 'invest_pro_dots_layer',
          type: 'circle',
          source: 'invest_pro_dots_source',
          filter: ['!', ['has', 'point_count']],
          paint: {
            'circle-color': 'white',
            'circle-radius': 10,
          },
        });

        // FIXME Labels layer
        window.map.addLayer({
          id: `invest_pro_dots_labels_layer`,
          type: 'symbol',
          source: `invest_pro_dots_source`,
          filter: ['has', 'point_count'],
          layout: {
            'text-field': ['get', 'point_count_abbreviated'],
            'text-size': 12,
          },
        });

        window.map.on('click', 'invest_pro_dots_cluster_layer', onClusterClick);
        window.map.on('click', 'invest_pro_dots_layer', onDotClick);
      }
    }
  };

  useEffect(() => {
    if (mapLoaded && dots) {
      if (window.map.getLayer('invest_pro_dots_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, dots]);

  return null;
}

export default InvestProDotsLayer;
